"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validationMessages = {
    type: 'Nieprawidłowa wartość',
    number: 'Pole musi być liczbą',
    money: 'Pole musi być liczbą',
    integer: 'Pole musi być liczbą całkowitą',
    required: 'Wartość pola jest wymagana',
    fieldRequired: 'Wartość pola jest wymagana',
    minimum: 'Minimalnie {{minimum}}',
    maximum: 'Maksymalnie {{maximum}}',
    exclusiveMinimum: 'Musi być większe niz {{exclusiveMinimum}}',
    exclusiveMaximum: 'Musi być mniejsze niz {{exclusiveMaximum}}',
    multipleOf: 'Musi być wielokrotnością {{multipleOf}}',
    maxLength: 'Tekst jest zbyt długi, maksymalnie {{maxLength}} znaków',
    minLength: 'Tekst jest zbyt krótki, minimalnie {{minLength}} znaków',
    maxItems: 'Zbyt dużo elementów, maksymalnie {{maxItems}}',
    minItems: 'Za mało elementów, minimalnie {{minItems}}',
    enum: 'Nieprawidłowa wartość',
    format: 'Nieprawidłowy format',
    pattern: 'Nieprawidłowy format',
    'format.nip': 'Nieprawidłowy format, NIP musi składać się z dziesięciu cyfr.',
    'format.url': 'Podaj poprawny adres URL',
    'format.email': 'Nieprawidłowy format, adres e-mail musi być wprowadzony w formacie nazwa@domena.',
    'format.kod': 'Nieprawidłowy format, kod pocztowy musi być wprowadzony w formacie xx-xxx i składać się z samych cyfr.'
};
exports.default = validationMessages;
//# sourceMappingURL=validationMessages.js.map